module.exports = __webpack_public_path__ + "img/img_04.38c60b86.png";